export const faqItems = [
  {
    question: 'À quel type d’entreprise vous adressez-vous ?',
    answer:
      'J’accompagne principalement des PME et ETI (de 50 à 5 000 salariés), ainsi que des filiales de grands groupes, dans l’industrie, la distribution, l’agroalimentaire et les services.',
  },
  {
    question: 'Combien de temps faut-il pour voir les premiers résultats ?',
    answer:
      'Les premiers gains apparaissent généralement dès le deuxième mois, sur les catégories les plus accessibles. Les gains structurels (stocks, organisation) se mesurent sur 6 à 12 mois.',
  },
  {
    question: 'Comment sont calculés vos honoraires ?',
    answer:
      'Selon la mission : au forfait, au temps passé ou avec une part variable indexée sur les économies réellement obtenues. Le modèle est toujours défini avec vous avant de commencer.',
  },
  {
    question: 'Travaillez-vous avec nos équipes ou à leur place ?',
    answer:
      'Avec elles. Je conduis les chantiers mais j’associe systématiquement vos acheteurs et approvisionneurs, pour que les compétences restent dans l’entreprise après ma mission.',
  },
  {
    question: 'Intervenez-vous à distance ?',
    answer:
      'Oui, une partie du travail peut se faire à distance. Mais je reste convaincue de l’importance du terrain : ateliers, entrepôts et rencontres fournisseurs se font sur place.',
  },
  {
    question: 'La confidentialité de nos données est-elle garantie ?',
    answer:
      'Toutes les missions sont encadrées par un accord de confidentialité. Vos données de dépenses et vos conditions fournisseurs ne sont jamais partagées.',
  },
];
